'use client'

import { AnalyticsEvent } from '../AnalyticsEventType'

export const sendAnalyticsEvent = (event: AnalyticsEvent) => {
    //@ts-expect-error Property 'dataLayer' does not exist on type 'Window & typeof globalThis'
    window.dataLayer = window.dataLayer || []
    //@ts-expect-error Property 'dataLayer' does not exist on type 'Window & typeof globalThis'
    window.dataLayer.push(event)
}
